import { combineReducers, configureStore } from '@reduxjs/toolkit';
import authApi from './apiSlice/auth/authApi';
import authSlice from './apiSlice/auth/authSlice';
import sportApi from './apiSlice/sportApi';
import userApi from './apiSlice/userApi';
import sportBackgroundApi from './apiSlice/sportBackgroundApi';
import teamApi from './apiSlice/teamApi';
import postApi from './apiSlice/post/postApi';
import friendApi from './apiSlice/friendApi';
import friendInvitationApi from './apiSlice/friendInvitationApi';
import userEducationApi from './apiSlice/userEducationApi';
import notificationApi from './apiSlice/notificationApi';
import careerApi from './apiSlice/careerApi';
import jobpostApi from './apiSlice/jobpost/jobpostApi';
import chatApi from './apiSlice/chat/chatApi';
import chatSlice from './apiSlice/chat/chatSlice';
import groupChatApi from './apiSlice/chat/groupApi';
import profileMediaApi from './apiSlice/profileMediaApi';
import jobUserApplyApi from './apiSlice/jobpost/jobUserApplyApi';
import postReactionApi from './apiSlice/post/postReactionApi';
import commentApi from './apiSlice/post/commentApi';
import commentReactionApi from './apiSlice/post/commentReactionApi';
import friendIntroductionApi from './apiSlice/friendIntroductionApi';
import companyApi from './apiSlice/companyApi';
import subscriptionApi from './apiSlice/subscription/subscriptionApi';
import analyticsApi from './apiSlice/analytics/analyticsApi';
import companyReportApi from './apiSlice/analytics/companyReportApi';
import individualStageApi from './apiSlice/individualStageApi';
import reviewApi from './apiSlice/reviewApi';
import searchApi from './apiSlice/searchApi';
import partnershipApi from './apiSlice/partnershipApi';
import quizApi from './apiSlice/quizApi';
import universitySpecialtyApi from './apiSlice/universitySpecialtyApi';
import gamificationApi from './apiSlice/gamification/gamificationApi';
import badgeApi from './apiSlice/badgeApi';
import workExperienceApi from './apiSlice/workExperienceApi';

const reducers = combineReducers({
  [authApi.reducerPath]: authApi.reducer,
  auth: authSlice,
  [careerApi.reducerPath]: careerApi.reducer,
  [sportApi.reducerPath]: sportApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [quizApi.reducerPath]: quizApi.reducer,
  [sportBackgroundApi.reducerPath]: sportBackgroundApi.reducer,
  [workExperienceApi.reducerPath]: workExperienceApi.reducer,
  [teamApi.reducerPath]: teamApi.reducer,
  [postApi.reducerPath]: postApi.reducer,
  [friendApi.reducerPath]: friendApi.reducer,
  [partnershipApi.reducerPath]: partnershipApi.reducer,
  [friendIntroductionApi.reducerPath]: friendIntroductionApi.reducer,
  [friendInvitationApi.reducerPath]: friendInvitationApi.reducer,
  [userEducationApi.reducerPath]: userEducationApi.reducer,
  [notificationApi.reducerPath]: notificationApi.reducer,
  [jobpostApi.reducerPath]: jobpostApi.reducer,
  [postReactionApi.reducerPath]: postReactionApi.reducer,
  [commentApi.reducerPath]: commentApi.reducer,
  [chatApi.reducerPath]: chatApi.reducer,
  [groupChatApi.reducerPath]: groupChatApi.reducer,
  chat: chatSlice,
  [profileMediaApi.reducerPath]: profileMediaApi.reducer,
  [jobUserApplyApi.reducerPath]: jobUserApplyApi.reducer,
  [commentReactionApi.reducerPath]: commentReactionApi.reducer,
  [companyApi.reducerPath]: companyApi.reducer,
  [subscriptionApi.reducerPath]: subscriptionApi.reducer,
  [analyticsApi.reducerPath]: analyticsApi.reducer,
  [companyReportApi.reducerPath]: companyReportApi.reducer,
  [individualStageApi.reducerPath]: individualStageApi.reducer,
  [reviewApi.reducerPath]: reviewApi.reducer,
  [searchApi.reducerPath]: searchApi.reducer,
  [universitySpecialtyApi.reducerPath]: universitySpecialtyApi.reducer,
  [gamificationApi.reducerPath]: gamificationApi.reducer,
  [badgeApi.reducerPath]: badgeApi.reducer,
});

export const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      careerApi.middleware,
      sportApi.middleware,
      userApi.middleware,
      quizApi.middleware,
      sportBackgroundApi.middleware,
      workExperienceApi.middleware,
      teamApi.middleware,
      postApi.middleware,
      friendApi.middleware,
      partnershipApi.middleware,
      friendIntroductionApi.middleware,
      friendInvitationApi.middleware,
      userEducationApi.middleware,
      notificationApi.middleware,
      jobpostApi.middleware,
      postReactionApi.middleware,
      commentApi.middleware,
      chatApi.middleware,
      groupChatApi.middleware,
      profileMediaApi.middleware,
      jobUserApplyApi.middleware,
      commentReactionApi.middleware,
      companyApi.middleware,
      subscriptionApi.middleware,
      analyticsApi.middleware,
      companyReportApi.middleware,
      individualStageApi.middleware,
      reviewApi.middleware,
      searchApi.middleware,
      universitySpecialtyApi.middleware,
      gamificationApi.middleware,
      badgeApi.middleware
    ),
});

export type TypeRootState = ReturnType<typeof store.getState>;
